var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9996 0C27.9411 0 36 7.9372 36 17.9966C36 27.906 27.9411 36 17.9996 36C8.05811 36 0 27.906 0 17.9966C0 7.9372 8.05811 0 17.9996 0Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8714 19.165L22.8629 15.5726H19.621V13.2417C19.621 12.2586 20.0738 11.3009 21.5258 11.3009H23V8.24232C23 8.24232 21.6622 8 20.383 8C17.7132 8 15.9684 9.72007 15.9684 12.8348V15.5726H13V19.165H15.9684V27.8492C16.5633 27.9485 17.1733 28 17.7947 28C18.416 28 19.026 27.9485 19.621 27.8492V19.165H22.8714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.51b6de24d302c41cad4b137c276923ea.svg";
export { ForwardRef as ReactComponent };